import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import PropTypes from "prop-types";
import MuiTypography from "@material-ui/core/Typography";
import classNames from "classnames";
export class Typography extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "render", () => {
      const {
        align,
        children,
        color,
        component,
        gutterBottom,
        noWrap,
        paragraph,
        variant,
        onClick,
        className,
        ...otherProps
      } = this.props;
      return /*#__PURE__*/React.createElement(MuiTypography, _extends({
        className: classNames(className, "prmbl-typography"),
        onClick: onClick,
        align: align,
        color: color,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant
      }, otherProps), children);
    });
  }
}
_defineProperty(Typography, "propTypes", {
  /**
   * Classes to apply to the root
   */
  className: PropTypes.string,
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(["inherit", "left", "center", "right", "justify"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(["inherit", "primary", "textSecondary", "secondary", "error", "initial"]),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,
  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button"]),
  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(["initial", "block", "inline"]),
  onClick: PropTypes.func
});
_defineProperty(Typography, "defaultProps", {
  align: "inherit",
  color: "initial",
  gutterBottom: false,
  noWrap: false,
  paragraph: false,
  variant: "body1",
  display: "initial"
});
export default Typography;